<template>
	<div class="ng-scope show-sticky-calc" :class="openModal ? 'modal-open' : ''" >
		<headerNavigation :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="bg-white">
			<div class="breadcrumb-container container ">
				<div class="row">
					<div class="col-xs-24">
						<div class="comp-breadcrumbs-container">
							<ul class="breadcrumbs-list clearfix breadcrumbs-not-empty">
								<li class="breadcrumb-list-item active">
									<a href="javascript:void()" @click="openPage('/')" class="site-secondary-link breadcrumb-link breadcrumb1">{{$t('common.home')}}</a>
								</li>
								<li class="breadcrumb-list-item ">
									<span class="breadcrumb-active-label breadcrumb2">{{categoryName}}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="article-info">
				<div class="content-area-infos">
					<h1 class="heading ">{{infos.title}}</h1>
					<p class="text">
						{{infos.subheading}}
					</p>
					<img :src="infos.img" class="banner" v-if="infos.img"/>
				</div>
			</div>
			<div class="article-contents-wrapper">
				<div class="article-contents">
					<div class="pb-12 article-content__wrapper">
						<div v-html="infos.content"></div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="page-content-container">
			<div class="page-static-container container">
				<div class="content-static-region">
					<div class="sms-wgt-html">
						<div class="static_or_form_content">
							<div class="container" style="padding:0;margin-bottom: 15px;text-align:justify;">
								<div v-html="contents"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
		<div v-if="openModal" class="modal-backdrop fade ng-scope in" style="z-index: 1040;"></div> 
	</div>
</template>

<script>
		import headerNavigation from '../../components/headerNavigation.vue'
		import footers from '../../components/footers.vue'
		import loginModal from '../../components/loginModal.vue'
		import {getArticle} from '../../api/api.js'
		export default {
			components: {
				headerNavigation,
				footers,
				loginModal
			},
			data() {
				return {
					isMobile: false,
					showLoginModal: false,
					openModal:false,
					articleNo:'',
					infos:{},
					categoryName:''
				};
			},
			created() {
				this.isMobile = this.webIsMobile()
				if(this.$route.query.no){
					this.articleNo = this.$route.query.no;
					this.matchCategory()
					this.init()
				}
			},
			methods: {
				init(){
					var that = this;
					let params = {
						type:this.articleNo
					}
					getArticle(params).then(res => {
						if (res.code == 200) {
							that.infos = res.data
						}
					})
				},
				openLoginMadal() {
					this.showLoginModal = true
					this.changeRegister(false)
				},
				closeLoinMadal() {
					this.showLoginModal = false
				},
				changeRegister(e) {
					this.$refs.loginRef.changeRegisterType(e)
					this.showLoginModal = true
				},
				matchCategory(){
					switch (Number(this.articleNo)){
						case 19:
							this.categoryName = this.$t('footer.regardingcolordifference')
							break;
						case 18:
							this.categoryName = this.$t('footer.notesforcompletion')
							break;
						case 17:
							this.categoryName = this.$t('footer.termsofservice')
							break;
						case 16:
							this.categoryName = this.$t('footer.aftersalespolicy')
							break;
						case 15:
							this.categoryName = this.$t('footer.deliveryinstructions')
							break;
						case 14:
							this.categoryName = this.$t('footer.orderingguide')
							break;
						case 13:
							this.categoryName = this.$t('footer.help&faqs')
							break;
						case 12:
							this.categoryName = this.$t('footer.joinus')
							break;
						case 10:
							this.categoryName = this.$t('footer.aboutus')
							break;
						case 9:
							this.categoryName = this.$t('login.privacypolicy')
							break;
						case 8:
							this.categoryName = this.$t('login.termsofservice')
							break;
						default:
							this.categoryName = ''
							break;
					}
				}
			}
		}
</script>

<style scoped>
	.global-header-spacer {
	    height: 60px !important;
	    display: block !important;
	}
</style>